import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-case-schedule',
  templateUrl: './case-schedule.component.html',
  styleUrls: ['./case-schedule.component.css']
})
export class CaseScheduleComponent implements OnInit {
  @Input() caseSchedule;
  @Output()
  childClick: EventEmitter<String> = new EventEmitter<String>();
  constructor() { }

  ngOnInit() {
  
  }

  changeCheckbox(d,i) {
    //console.log("SCHEDULE COMP ..: ", d, i)
    this.caseSchedule['items'][d]['value'][i]['value']  = !this.caseSchedule['items'][d]['value'][i]['value']
    this.childClick.emit(this.caseSchedule)
  }
}



// WEBPACK FOOTER //
// c:/Dev/Angular/liceo/src/app/case-schedule/case-schedule.component.ts